import { useLocation, useNavigate } from "react-router-dom";

const useNavigationScenarios = ({ scenarios, enableLogs = false }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const match = scenarios.find(({ id, when }) => {
    const result = when(location.pathname);
    if (enableLogs) {
      console.log(`[nav] ${id}:`, result, "| pathname:", location.pathname);
    }
    return result;
  });
  if (match) {
    if (enableLogs) {
      console.log(match.log);
    }
    navigate(match.target, match.options);
  }
};

export default useNavigationScenarios;
